import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import twemoji from 'twemoji';
import { MESSAGE_TYPE } from '../../../../actions';
import Remarkable from 'remarkable';
import RemarkableIframify from '../../../../../../../common/remarkable/iframify';
import RemarkableShortenUrl from '../../../../../../../common/remarkable/shortenurl';
import RemarkableFullScreenImg from '../../../../../../../common/remarkable/fullscreenimg';
import RemarkableEmojify from '../../../../../../../common/remarkable/twemojify';
import RemarkablePhoneNumberFix from '../../../../../../../common/remarkable/phonenumberfix';
import LoaderAnimation from '../../../../../../../common/icons/mojorange/loader-animation.svg';
import LoaderAnimationPortal from '../../../../../../../common/icons/loader-animation-portal.svg';
import CallManIcon from '../../../../../../../common/icons/mojorange/call_man.svg';
import TypingIcon from '../../../../../../../common/icons/typing.svg';

const escapeHTML = (message) => {
   return message.indexOf('pay.bm.pl') > -1 ||
        message.indexOf('orange.pl/hapi/ep/app/entry') > -1
        ? message
        : message.replace(/&/g, '&amp;'); //.replace(/</g,'&lt;').replace(/>/g,'&gt;'); // escaping < > chars removed because same is done by Remarkable.
};

const md = new Remarkable('full', {
    html: false,
    xhtmlOut: false,
    breaks: true,
    langPrefix: 'md-',
    linkify: true,
    typographer: true,
    quotes: '„”\'\'',
    linkTarget: '_blank'
});
md.use(RemarkableShortenUrl); // make URL links with shorter title
md.use(RemarkableIframify); // detect youtube links
md.use(RemarkableFullScreenImg); // mark images for full screen
md.use(RemarkableEmojify); // change :emoji: to unicode characters
md.use(RemarkablePhoneNumberFix); // avoid paring * or ** on phone numbers

const formatMessage = (message) => {
    if (!message) return message;

    // message is plain text or markdown text
    message = escapeHTML(message);
    // message is safe for escape codes
    message = md.render(message);
    // message = message.replace(/(\r\n|\r|\n)/g, '<br>');
    message = twemoji.parse(message, {
        folder: 'svg',
        ext: '.svg',
		base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/',
        callback: function (icon, options) {
            switch (icon) {
                case 'a9': // © copyright
                case 'ae': // ® registered trademark
                case '2122': // ™ trademark
                case '21a9': // ↩ return
                    return false;
            }
            return ''.concat(options.base, options.size, '/', icon, options.ext);
        }
    });
    return message;
};

class TextMessage extends React.Component {
    render() {
        const { id, message, type, icon, theme } = this.props;
        const spinner = theme.includes('mojorange2') ? (
            [
                <div key="spinner1" className="callman">
                    <CallManIcon />
                </div>,
                <div key="spinner2" className="loader">
                    <LoaderAnimation />
                </div>
            ]
        ) : (
            <div key="spinner1" className="loader-portal">
                <LoaderAnimationPortal />
            </div>
        );

        const content =
            type === MESSAGE_TYPE.AGENT_TYPING ? (
                <div className="message-container">
                    <div className="typing">
                        <TypingIcon />
                    </div>
                </div>
            ) : (
                <div
                    className="message-container"
                    onClick={(e) => this.props.onClick(e, id)}
                    dangerouslySetInnerHTML={{
                        __html: formatMessage(message)
                    }}
                />
            );
        return (
            <React.Fragment>
                {typeof icon === 'string' && (
                    <div className="icon-container">{icon === 'spinner' && spinner}</div>
                )}
                {content}
            </React.Fragment>
        );
    }
}

TextMessage.defaultProps = {
    message: '',
    icon: null
};

TextMessage.propTypes = {
    message: PropTypes.string.isRequired,
    icon: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        theme:
            state.settings.widget && state.settings.widget.theme
                ? state.settings.widget.theme.split(' ')
                : ['default']
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextMessage);
